// src/config.js
export const API_KEY = 'd2defc26117c141282c580886b3a87be';
export const FETCH_INTERVAL = 300000; // 5 minutes in milliseconds
export const CITIES = [
  'Delhi', 'Mumbai', 'Chennai', 'Bangalore', 'Kolkata', 'Hyderabad' , 'Ahmedabad', 'Jaipur', 'Gurugram'
];
// export const TEMPERATURE_THRESHOLD = 35;
// export const CONSECUTIVE_ALERTS = 2;